<template lang="pug">
  
  v-card.rounded-lg(flat)
    v-card-title {{$t("account.subscription")}}
    v-card-text(v-if="stripeSubscriptions && stripeSubscriptions.length")
      v-list-item(three-line v-for="(subscription, index) in stripeSubscriptions" :key="index")
        v-list-item-avatar(tile, size="125")
          v-img.videoThumbnail(v-if="subscription.plan.product.images.length" :src='subscription.plan.product.images[0]')
        v-list-item-content
          v-list-item-title {{subscription.plan.product.name}}
          v-list-item-subtitle {{subscription.plan.product.description}}
          v-list-item-subtitle   
            | {{formatDateTo((subscription.start_date * 1000), 'L')}} - {{subscription.cancel_at ? (formatDateTo((subscription.cancel_at * 1000), 'L')): "Open"}}
          v-list-item-subtitle 
            v-chip(small color="success") 
              v-icon.mr-2(small) check_circle
              | Active
    v-card-text(v-else)
      v-alert(type="info" icon="mdi-firework" prominent color="grey") 
        v-row(align='center')
          v-col.grow
            | {{$t('account.testPhase')}}
          v-col.shrink
            v-btn(link href="mailto:support@simplymotion.de?subject=Abo abschließen") {{$t('account.testPhaseAction')}}
    v-divider
    v-card-actions  
      UpdateStripeCustomerIdDialog(:stripeSession="stripeSession" :currentTenant="tenantId")
      v-spacer
      v-btn(color='accent', :disabled="enableStripeLink" :loading="stripeLoading" :text="!stripeLoading", :depressed="stripeLoading", @click="goToStripe") {{$t('account.manageSubscription')}}
</template>

<script>
import { mapState } from "vuex";
import date from "@/utils/date";
import UpdateStripeCustomerIdDialog from "@/components/admin/UpdateStripeCustomerIdDialog.vue";
export default {
  components: {
    UpdateStripeCustomerIdDialog,
  },
  props: ["tenantId"],
  computed: {
    ...mapState({
      stripeLoading: (state) => state.account.loading,
      enableStripeLink: (state) =>
        !state.account.loading && !state.account.stripeSession?.url,
      stripeSubscriptions: (state) => state.account.stripeSubscriptions,
      stripeSession: (state) => state.account.stripeSession,
    }),
  },
  created() {
    this.$store.dispatch("account/GET_STRIPE_SUBSCRIPTIONS", this.tenantId);
  },
  methods: {
    ...date,
    goToStripe() {
      const url = this.stripeSession.url;
      if (url) {
        window.location.href = url;
      }
    },
  },
};
</script>
